import React from "react";
import { CommunityFeedType } from "../../types";
import Tooltip from "../Tooltip/tooltip";

type ModalActivityReaderProps = {
  communityFeed: CommunityFeedType | undefined;
  loadings: boolean;
  modalRemove: boolean;
  //feedLikes: FeedLikeType | undefined;
};

const ModalActivityReader: React.FC<ModalActivityReaderProps> = ({
  communityFeed,
  loadings,
  modalRemove,
  //feedLikes,
}) => {
  // const commenters = communityFeed?.comments.map((a) => {
  //   const creatorName = `${a.creator.firstName} ${a.creator.lastName}`;
  //   return creatorName;
  // });

  // console.log(feedLikes);

  const commentersSet = new Set();

  const commenters = communityFeed?.comments.map((comment) => {
    const creatorName = `${comment.creator.firstName} ${comment.creator.lastName}`;

    // Check if the user ID is already in the Set
    if (!commentersSet.has(comment.creator.id)) {
      // If not, add it to the Set and return the commenter's name
      commentersSet.add(comment.creator.id);
      return creatorName;
    }

    // If the user ID is already in the Set, return an empty string
    return "";
  });

  // Filter out the empty strings from the commenters array
  const uniqueCommenters = commenters?.filter((commenter) => commenter !== "");

  const totalLikes = communityFeed?.feedLikes?.length || 0;
  const totalComments =
    communityFeed?.comments && communityFeed?.comments?.length;

  // console.log(totalLikes, 'totalLikes');
  // console.log(loadings, "loadings");

  return (
    <div className="w-full flex justify-between text-[#646464] font-Poppins text-[8px] lg:mb-1 h-5 mx-auto lg:text-[14.7px] lg:font-SegoeUI font-normal px-4">
      <div className="flex text-searchCol w-[64%]">
        {loadings ? (
          <div className="flex">
            {loadings && modalRemove
              ? totalLikes > 1
                ? `${totalLikes - 1} likes`
                : totalLikes === 1 && ""
              : `${totalLikes + 1} like${totalLikes > 1 ? "s" : ""}`}
          </div>
        ) : (
          communityFeed &&
          communityFeed?.feedLikes?.length > 0 && (
            <div className="flex">{`${totalLikes} like${totalLikes > 1 ? "s" : ""}`}</div>
          )
        )}
      </div>
      <div className="flex gap-1 w-[35%] justify-end text-searchCol relative">
        {communityFeed?.comments && communityFeed.comments.length > 0 && (
          <div className="flex gap-1 cursor-pointer">
            <Tooltip
              list={uniqueCommenters}
            >{`${totalComments} comments`}</Tooltip>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalActivityReader;
